import React from 'react'
import styled from 'styled-components'
import Location from './Location'
import { ItemWrapper, Wrapper } from '@pages/Dashboard/styles'

const MapWrapper = styled(ItemWrapper)`
    min-height: 43rem;
`

const Maps = () => {
    return (
        <Wrapper>
            <MapWrapper fullWidth>
                <Location />
            </MapWrapper>
        </Wrapper>
    )
}

export default Maps